/**
 * FNV-1a hash → 8-char hex string.
 * Avoids sending raw Appwrite user IDs to third-party analytics.
 */
export function hashUserId(userId: string): string {
  let hash = 0x811c9dc5; // FNV offset basis (32-bit)
  for (let i = 0; i < userId.length; i++) {
    hash ^= userId.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // FNV prime (32-bit)
  }
  // Convert to unsigned 32-bit and then to 8-char hex
  return (hash >>> 0).toString(16).padStart(8, '0');
}
